import React, { useMemo } from "react";
import DocumentCard from "components/card/DocumentCard";
import { FileCheck, TrendingUp, FileText } from "lucide-react";
import NoDocument from "./NoDocument";

const icons = {
    Contract: <FileCheck className="w-4 h-4 text-blue-600" />,
    Promotion: <TrendingUp className="w-4 h-4 text-purple-600" />,
    Compensation: <FileText className="w-4 h-4 text-emerald-600" />,
};

const AllDocuments = ({ documents = [] }) => {
    const groupedDocuments = useMemo(() => {
        const groups = {};
        
        documents.forEach(doc => {
            const docType = doc.doc_type_name || doc.doc_type?.opt_name;
            
            if (!groups[docType]) {
                groups[docType] = [];
            }
            groups[docType].push(doc);
        });
        
        return Object.entries(groups).map(([category, docs]) => ({
            category,
            docs,
            icon: icons[category] || <FileText className="w-4 h-4 text-gray-600" />
        }));
    }, [documents]);

    if (documents.length === 0) {
        return (
            <>
                <NoDocument/>
            </>
        );
    }

    return (
        <div className="flex flex-col">
            {groupedDocuments.map((group, i) => (
                <div key={group.category} >
                    <div className="space-y-3">
                        <h3 className="text-[16px] font-semibold flex items-center gap-2">
                            {group.icon} {group.category} ({group.docs.length})
                        </h3>

                        <div className="flex flex-col gap-3">
                            {group.docs.map((doc) => (
                                <DocumentCard
                                    key={doc.doc_id}
                                    title={doc.doc_title}
                                    description={doc.doc_description}
                                    status={doc.doc_status_name}
                                    date={doc.doc_date}
                                    size={doc.doc_size}
                                    icon={group.icon}
                                    documentData={doc}
                                    onDownload={() => console.log(`Download ${doc.title}`)}
                                />
                            ))}
                        </div>
                    </div>
                    {i !== groupedDocuments.length - 1 && 
                        <div className="bg-gray-200 h-px w-full my-6"></div>
                    }
                </div>
            ))}
        </div>
    );
};

export default AllDocuments;
